import { createTheme } from '@mui/material/styles';
import { brand } from '../config/appConfig';

/**
 * Tema MUI del sitio de afiliados, generado desde la marca en runtime.
 * TODO: si el tema se mantiene igual al de empresas, mover a @atsa/shared.
 */
export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: brand.palette.primary,
    secondary: brand.palette.secondary,
    background: brand.palette.background,
    text: brand.palette.text,
    error: brand.palette.error,
    success: brand.palette.success,
    warning: brand.palette.warning,
    info: brand.palette.info,
  },
  typography: { fontFamily: brand.typography.fontFamily },
  shape: { borderRadius: 10 },
  components: {
    MuiButton: { styleOverrides: { root: { borderRadius: 8 } }, defaultProps: { disableElevation: true } },
  },
});

export default theme;
